import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadLastSessionFailed, loadLastSessionSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadLastSession(action) {
  try {
    const {
      payload = {},
    } = action;
    const url = `${BACKEND_URL}/dashboard/load-last-session`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(loadLastSessionSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadLastSessionFailed());
      yield call(rejectActionPromise(action, data.data));
    }
  } catch (e) {
    yield put(loadLastSessionFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
